import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import router from '../router'
import Vue from 'vue'

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_PORTAL_SENTRY_DSN || '',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'portal.dripcapital.com', /^\//]
    })
  ],
  ignoreErrors: ['code 401', 'timeout', 'code 422'],
  tracesSampleRate: 1.0,
  environment: process.env.VUE_APP_ENVIRONMENT
  // Use for debugging sentry trackings
  // beforeSend(event, hint) {
  //   const error = hint.originalException
  //   console.log('message', error?.message)
  //   console.log('event', event)
  //   return event
  // }
})
